import SettingsModal from './settings-modal.connect'

export default SettingsModal
